import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';

export const OrderTableItemMobileWrapper = styled.div`
    border-bottom: 2px solid ${({ theme }) => theme.colors['Level 1']};
    padding-top: ${({ theme }) => theme.spacers.L};
    padding-bottom: ${({ theme }) => theme.spacers.XXL};
    display: flex;
    flex-direction: column;
    &:first-child {
        padding-top: 0px;
    }
`;

export const PriceWrapper = styled.div`
    padding-bottom: ${({ theme }) => theme.spacers.S};
    width: 70%;
    margin-left: auto;
    margin-right: 0;
    padding-left: 16px;
    > * {
        display: inline;
    }
`;

export const PlanDurationNote = styled(Typography).attrs({
    tag: 'h4',
})`
    color: ${({ theme }) => theme.colors['Level 4']};
    width: 70%;
    margin-left: auto;
    margin-right: 0;
    padding-left: 16px;
`;

export const Actions = styled.div`
    display: flex;
    margin-top: ${({ theme }) => theme.spacers.XL};
    width: 70%;
    margin-left: auto;
    margin-right: 0;
    padding-left: 16px;
`;

export const ActionsWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 5;
    margin-right: -10px;

    ${(props) => props.readOnly
        && css`
            margin-right: 0;
        `}
`;

export const ActionsTitle = styled(Typography).attrs({
    tag: 'p',
})`
    color: ${({ theme }) => theme.colors.Foreground};
    align-self: center;
    padding-right: ${({ theme }) => theme.spacers.L};
`;

export const Remover = styled.div`
    display: inline-block;
    align-self: flex-end;
    width: 25px;
    height: 25px;
    background: #f4f3f3;
    color: #000;
    border-radius: 2px;
    line-height: 21px;
    text-align: center;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 16px 5px 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:hover {
        background: #f7f5f5;
    }
`;
